import wretch from 'wretch';
import * as v from 'valibot';
import { localizedErrorHandlers } from '@fe-core';
import {
  SelfregSessionSchema,
  TSelfregSessionDetails,
} from '@api/io/selfreg.io';
import { SelfenrollmentRequestSchema } from '@api/io/selfreg.enrollment.io';

export const getSelfregSession = async ({
  baseUrl,
  sessionId,
}: {
  baseUrl: string;
  sessionId: string;
}): Promise<TSelfregSessionDetails> => {
  const url = `${baseUrl}/selfreg/sessions/${sessionId}`;
  const instance = wretch(url, {
    credentials: 'include',
  }).get();

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(SelfregSessionSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output;
    } else {
      console.error(
        'fe-learner-catalog | getSelfregSession | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid getSelfregSession response');
    }
  });
};

type TSelfenrollmentRequest = v.Input<typeof SelfenrollmentRequestSchema>;
export const enroll = async ({
  baseUrl,
  sessionId,
}: {
  baseUrl: string;
  sessionId: string;
}): Promise<TSelfenrollmentRequest> => {
  const url = `${baseUrl}/selfreg/sessions/${sessionId}/enroll`;
  const instance = wretch(url, {
    credentials: 'include',
  }).post();

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(
      SelfenrollmentRequestSchema,
      response,
    );

    if (validatedResponse?.success) {
      return validatedResponse.output;
    } else {
      console.error(
        'fe-learner-catalog | enroll selfreg | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid selfreg enroll response');
    }
  });
};
